import { render, staticRenderFns } from "./CustomerCenter.vue?vue&type=template&id=0e462c9a&scoped=true&"
import script from "./CustomerCenter.vue?vue&type=script&lang=ts&"
export * from "./CustomerCenter.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCenter.vue?vue&type=style&index=0&id=0e462c9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e462c9a",
  null
  
)

export default component.exports